import { registerFormInputComponent } from '@vendure/admin-ui/core';
import { MaxValueInputComponent } from './input-form.component';

export default [
    registerFormInputComponent('max-value-input', MaxValueInputComponent),
];
